import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import Loader from 'shared/components/Loader';

import { ImageProps } from './types';

const StyledImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledImage = styled.img`
  max-width: 100%;
`;

const Image = ({
  src,
  className,
  imageClassName,
  onClick,
}: ImageProps) => {
  const [isLoading, setLoading] = useState(true);

  const handleLoad = useCallback(() => {
    setLoading(false);
  }, []);

  const handleError = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <StyledImageContainer className={className} onClick={onClick}>
      <StyledImage
        className={imageClassName}
        src={src}
        onLoad={handleLoad}
        onError={handleError}
      />
      {isLoading && <Loader name='line-scale' />}
    </StyledImageContainer>
  );
};

export default Image;
